import React from 'react';
import { QueryKey } from 'react-query';
import includes from 'lodash/includes';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterTagIdValue,
  UniversalFilterTagIdModes,
  UniversalFilterTagIdOnChange
} from './UniversalFilterTagId.types';

import { useUniversalFilterTagId } from './hooks/useUniversalFilterTagId';

import { TagsMultiSelect } from '../../../../../main/tags/helpers/TagsMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterTagIdProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterTagIdValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterTagIdOnChange;
}

function UniversalFilterTagId({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange
}: UniversalFilterTagIdProps) {
  const { modeOptions, filterState, handleModeChange, handleTagIdsChange } =
    useUniversalFilterTagId({ filterStateCacheKey, filterValue, onChange });

  return (
    <UniversalFilterTemplate<UniversalFilterTagIdModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      {includes(
        [UniversalFilterTagIdModes.CONTAINS_ANY_OF],
        filterState.mode
      ) ? (
        <TagsMultiSelect
          key={filterState.mode}
          value={filterState.tagIds || []}
          autoFocus={autoFocus}
          onChange={handleTagIdsChange}
        />
      ) : null}
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterTagId;
